module.exports = __webpack_public_path__ + "static/media/017-thermometer-7.b2a58d9d.svg";